import { Accordion, Stack } from "@mantine/core";
import type { SiteWizard } from "../../../../../utils/backend-types";
import type { AssignmentType } from "../../OnboardingWizard.constants";
import { VollmachtMsb, vollmachtMsbId } from "./VollmachtMsb";
import {
  VollmachtVermarkter,
  vollmachtVermarkterId
} from "./VollmachtVermarkter";

type VollmachtAssignmentProps = {
  siteWizard: SiteWizard;
  updateSiteWizard: (type: AssignmentType) => Promise<void>;
};

function VollmachtAssignment({
  siteWizard,
  updateSiteWizard
}: VollmachtAssignmentProps) {
  const siteId = siteWizard.id;
  const isDisabled = !siteWizard.phases.configuration.done;

  return (
    <Accordion
      defaultValue={[vollmachtMsbId, vollmachtVermarkterId]}
      mt="xs"
      multiple
      styles={{
        chevron: {
          marginInlineStart: "0.25rem"
        }
      }}
      variant="separated"
    >
      <Stack gap={0}>
        {siteWizard.phases.msbauthority.displayPhase && (
          <VollmachtMsb
            isDisabled={isDisabled}
            phase={siteWizard.phases.msbauthority}
            siteId={siteId}
            updateSiteWizard={updateSiteWizard}
          />
        )}
        {siteWizard.phases.dataloadauthority.displayPhase && (
          <VollmachtVermarkter
            isDisabled={isDisabled}
            phase={siteWizard.phases.dataloadauthority}
            siteId={siteId}
            updateSiteWizard={updateSiteWizard}
          />
        )}
      </Stack>
    </Accordion>
  );
}

export { VollmachtAssignment };
